import { createAction, props } from '@ngrx/store';
import { LoadOptions } from '../models/load-options.model';

export const loadLoadOptions = createAction(
  '[Load Options] Load Load Options',
  props<{ organizationId: string }>()
);

export const loadLoadOptionsSuccess = createAction(
  '[Load Options] Load Load Options Success',
  props<{ loadOptions: LoadOptions }>()
);

export const loadLoadOptionsFailure = createAction(
  '[Load Options] Load Load Options Failure',
  props<{ error: any }>()
);
